import React, { useContext, useState } from 'react'
import styled from '@emotion/styled'
import { SiteConfigContext } from '@jelly/components'
import { AdvertisingDisclosureModal } from './AdvertisingDisclosureModal'

const DisclosureWrapper = styled.div`
	background: ${({ theme }) => `${theme.colors.gray[200]}`};
	color: inherit;
	font-size: 13px;
	margin: 0;
	padding: 10px 7% 10px;
	position: relative;
	text-align: center;
	min-height: 30px;
	width: 100%;
	letter-spacing: -0.07px;
	line-height: 0.875rem;
	${({ theme }) => theme.fonts.primary};

	a {
		color: ${({ theme }) => theme.colors.secondary};
		text-decoration: underline;
	}
	${({ theme }) => theme.MQ.S} {
		padding: 10px 10% 10px;
	}
	${({ theme }) => theme.MQ.M} {
		padding: 7px 15% 7px;
	}
`
const LearnMore = styled.button`
	background: transparent;
	border: none;
	color: ${({ theme }) => theme.colors.secondary};
	cursor: pointer;
	font-family: Poppins;
	font-size: 13px;
	font-weight: bold;
	letter-spacing: 0;
	line-height: 20px;
	margin: 0;
	padding: 0 5px;
	text-decoration: underline;
`

/**
 *	Advertising Disclaimer Text and Modal
 */
export function AdvertisingDisclosure() {
	const {
		siteConstants: {
			META_DATA: { applicationName },
		},
	} = useContext(SiteConfigContext)
	const [showModal, setShowModal] = useState(false)

	return (
		<>
			<DisclosureWrapper>
				{applicationName} receives compensation from the companies listed on this page.{' '}
				<LearnMore onClick={() => setShowModal(true)}>Learn More</LearnMore>
			</DisclosureWrapper>
			<AdvertisingDisclosureModal show={showModal} onClose={() => setShowModal(false)} />
		</>
	)
}
